export default __webpack_public_path__ + "static/media/breakfast_9.15b558a2.jpg";